import React from 'react';
import { twMerge } from 'tailwind-merge';
import LabelPlate from './LabelPlate';

interface NamePlateProps {
    label: string | null;
    isCompact?: boolean;
    /** Kept in the layout but invisible (a screen share not shown in-grid). */
    hidden?: boolean;
    /** Extra classes (e.g. a wider max-width or tighter padding) merged last. */
    className?: string;
}

/** The participant name / screen-share label plate. */
const NamePlate: React.FC<NamePlateProps> = ({
    label,
    isCompact = false,
    hidden = false,
    className,
}) => (
    <LabelPlate
        isCompact={isCompact}
        testId="meeting-user-name"
        className={twMerge(
            // Shrink into whatever row space the status icons leave (min-w-0)
            // and ellipsis there, instead of capping at an arbitrary fraction
            // of the whole tile width.
            'min-w-0',
            hidden ? 'invisible' : '',
            className,
        )}
    >
        {/* Truncate on the text itself: the plate is a flex container, where
            text-ellipsis doesn't apply, so a long name hard-clips. A flex item
            needs min-w-0 to shrink below its content, letting it ellipsis inside
            the capped plate instead. */}
        <span className="min-w-0 truncate">{label}</span>
    </LabelPlate>
);

export default NamePlate;
